import { Text, Box, Badge } from "@mantine/core";
import React from "react";
import useStyles from "./style";
import { DemoBookButton } from "../../components/BookADemoButton/DemoBookButton";
import { PopupButton } from "react-calendly";

const HeroSection = () => {
  const { classes } = useStyles();
  return (
    <Box className={`${classes.heroSection} ${classes.InlinePadding}`}>
      <Box className={classes.heroSectionShadow}></Box>
      <Box className={classes.heroContent}>
        <Box className={classes.welcomeText}>
          <Box>Welcome to Skypoint</Box>
        </Box>
        <Text className={classes.primaryHeading}>
          Manage all your Provider Workflows
        </Text>
        <Text className={classes.heroSectionText}>
          Easily manage your provider notes, documentation, medications, and
          communicate with your providers from one platform.
        </Text>
        <PopupButton
            className={classes.heroSecDemoBtn}
            url="https://calendly.com/ogiso-demo/30min?primary_color=ffba45"
            rootElement={document.getElementById("root")}
            text="Request a Demo"
          />
        <img
          src={"/assets/images/herosectionImg.png"}
          alt="heroSectionImg"
          className={classes.heroImg}
        />
      </Box>
    </Box>
  );
};

export default HeroSection;
